import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Heading from "../../components/Ui/Heading";
import { useGetAddToCartDataByEmailQuery } from "../../redux/addToCart/addToCartApi";
import SingleProductCard from "./SingleProductCard";
import SubTotal from "./SubTotal";

import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../init.firebase";
import { useState } from "react";
import { useEffect } from "react";

const Cart = () => {
  const [haveUser, setHaveUser] = useState(true);
  const [user] = useAuthState(auth);

  const {
    data: addToCartData,
    isLoading,
    isError,
  } = useGetAddToCartDataByEmailQuery(user?.email, { skip: haveUser });

  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user?.email]);

  let content = null;
  if (user?.email) {
    if (isLoading) {
      content = <p>Loading..</p>;
    }
    if (!isLoading && isError) {
      content = <p className="text-danger">There is something wrong!</p>;
    }
    if (!isLoading && !isError && addToCartData?.length === 0) {
      content = <p>Your bag is empty</p>;
    }
    if (!isLoading && !isError && addToCartData?.products?.length > 0) {
      content = addToCartData?.products?.map((cart) => (
        <SingleProductCard cart={cart} />
      ));
    }
  }

  const subTotalPrice = addToCartData?.products?.reduce(
    (totalValue, currentValue) =>
      totalValue +
      currentValue?.quantity * parseInt(currentValue?.product?.price),
    0
  );
  return (
    <div>
      <Heading className="text-center fs-5">Shopping Bag</Heading>
      <Container>
        <Row>
          <Col lg={8}>{content}</Col>
          <Col lg={4}>
            <SubTotal subTotalPrice={subTotalPrice} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Cart;
